import * as types from './types';

export default {
    [types.SET_MADE_RESERVATIONS](state, madeReservations) {
        state.madeReservations = madeReservations;
    },
    [types.SET_RECEIVED_RESERVATIONS](state, receivedReservations) {
        state.receivedReservations = receivedReservations;
    },
};